// Coerce an unknown value into a flat array of UUID strings, tolerating a bare array or objects
// with a `uuid` field. Shared by the excluded-mod-groups and excluded-modifiers normalizers.
const toUuidList = (list: unknown): string[] => {
  if (!Array.isArray(list)) return [];
  return list
    .map(entry => (typeof entry === 'string' ? entry : (entry as { uuid?: string })?.uuid))
    .filter((uuid): uuid is string => Boolean(uuid));
};

export const normalizeExcludedModGroups = (data: unknown): string[] =>
  toUuidList(
    Array.isArray(data)
      ? data
      : (data as { excludedModGroupUuids?: unknown })?.excludedModGroupUuids,
  );

export const normalizeExcludedModifiers = (data: unknown): string[] =>
  toUuidList(
    Array.isArray(data)
      ? data
      : (data as { excludedModifierUuids?: unknown })?.excludedModifierUuids,
  );

// Whether this modifier is allowed to nest child mod groups. Nesting must be affirmatively
// confirmed: only an explicit `nestingAllowed: true` unlocks the feature.
export const normalizeNestingAllowed = (data: unknown): boolean =>
  (data as { nestingAllowed?: unknown })?.nestingAllowed === true;
